export default __webpack_public_path__ + "2bfbf4cfd59636ad6c4baf614a1b2fab.jpg";